"use client";

import { Core, Decorative } from "@faire/design-tokens";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled, { css } from "styled-components";

import { PROMO_HIGHLIGHT } from "@faire/retailer/consts/colors";
import { useSettingUpdateSaleColorCopy } from "@faire/retailer/settings/useSettingUpdateSaleColorCopy";

export const NoneHighlightPromoText: React.FC<{
  promoText: string;
}> = ({ promoText }) => {
  const isUpdateSaleColorCopy = useSettingUpdateSaleColorCopy();
  return (
    <StyledTypography
      data-test-id="non-highlighted-promo-text"
      $showUpdateSaleColorCopy={isUpdateSaleColorCopy}
      variant={
        isUpdateSaleColorCopy ? "labelSansRegular" : "paragraphSansRegular"
      }
      color={
        isUpdateSaleColorCopy ? Core.text.default : Decorative.shade.orange
      }
    >
      {promoText}
    </StyledTypography>
  );
};

const StyledTypography = styled(Typography)<{
  $showUpdateSaleColorCopy: boolean;
}>`
  ${(props) =>
    props.$showUpdateSaleColorCopy &&
    css`
      background-color: ${PROMO_HIGHLIGHT};
      border-radius: 4px;
      display: inline-block;
      padding: 2px 3px;
    `}
`;
